// import

import type {RequestOpts} from '@sitearcade/request';
import {request} from '@sitearcade/request';

import {trackHeaders} from 'libs/tracking';

// export

export default async function hubApi(path: string, opts: RequestOpts = {}) {
  return request({
    baseUrl: `${process.env.RESOLVED_URL}/api`,
    response: 'json',
    useCors: true,
    useJson: true,
    onlyBody: true,
    sameOrigin: true,
    path,

    ...opts,

    headers: {
      ...trackHeaders(),
      ...opts.headers,
    },
  });
}
